import * as React from 'react'
import { memo } from 'react'
const SvgInstagram = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16.004 16"
  >
    <path d="M8.005 3.898a4.1 4.1 0 1 0 4.1 4.1 4.1 4.1 0 0 0-4.1-4.1Zm0 6.765a2.667 2.667 0 1 1 2.667-2.667 2.672 2.672 0 0 1-2.667 2.667Zm5.227-6.937a.957.957 0 1 1-.957-.957.955.955 0 0 1 .955.962Zm2.717.971a4.735 4.735 0 0 0-1.294-3.348 4.766 4.766 0 0 0-3.35-1.292c-1.321-.075-5.28-.075-6.6 0a4.759 4.759 0 0 0-3.357 1.289A4.751 4.751 0 0 0 .056 4.698c-.075 1.321-.075 5.28 0 6.6a4.735 4.735 0 0 0 1.292 3.352 4.772 4.772 0 0 0 3.357 1.294c1.321.075 5.28.075 6.6 0a4.735 4.735 0 0 0 3.352-1.292 4.766 4.766 0 0 0 1.292-3.352c.075-1.321.075-5.277 0-6.6Zm-1.707 8.015a2.7 2.7 0 0 1-1.521 1.521c-1.053.418-3.552.321-4.716.321s-3.667.093-4.716-.321a2.7 2.7 0 0 1-1.521-1.521c-.42-1.049-.323-3.549-.323-4.711s-.093-3.667.321-4.716a2.7 2.7 0 0 1 1.521-1.522c1.053-.417 3.552-.321 4.718-.321s3.667-.093 4.716.321a2.7 2.7 0 0 1 1.521 1.521c.418 1.053.321 3.552.321 4.716s.095 3.663-.323 4.717Z" />
  </svg>
)
const Memo = memo(SvgInstagram)
export default Memo
